import * as React from 'react';

import { Constants } from '@dndbeyond/character-rules-engine/es';

import HalfProficiencyIcon from './HalfProficiencyIcon';
import NoProficiencyIcon from './NoProficiencyIcon';
import ProficiencyIcon from './ProficiencyIcon';
import TwiceProficiencyIcon from './TwiceProficiencyIcon';

interface Props {
    proficiencyLevel: number;
    isModified: boolean;
    theme?: any;
}
export default class ProficiencyLevelIcon extends React.PureComponent<Props> {
    static defaultProps = {
        isModified: false,
    };

    render() {
        const { proficiencyLevel, isModified, theme } = this.props;

        let IconComponent: React.ComponentType<any> | null = null;

        switch (proficiencyLevel) {
            case Constants.ProficiencyLevelEnum.NONE:
                IconComponent = NoProficiencyIcon;
                break;
            case Constants.ProficiencyLevelEnum.HALF:
                IconComponent = HalfProficiencyIcon;
                break;
            case Constants.ProficiencyLevelEnum.FULL:
                IconComponent = ProficiencyIcon;
                break;
            case Constants.ProficiencyLevelEnum.EXPERT:
                IconComponent = TwiceProficiencyIcon;
                break;
            default:
            //not implemented
        }

        if (IconComponent === null) {
            return null;
        }

        return <IconComponent className="ddbc-proficiency-level-icon" isModified={isModified} theme={theme} />;
    }
}
